import * as React from "react";
import { Check, Minus } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Checkbox self-contained (sem @radix-ui) com visual shadcn.
 * - checked: true | false | "indeterminate"
 * - onCheckedChange: (nextChecked: boolean) => void
 */
function Checkbox({ className, checked = false, onCheckedChange, disabled, ...props }) {
  const isIndeterminate = checked === "indeterminate";
  const isChecked = checked === true;

  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={isIndeterminate ? "mixed" : isChecked}
      disabled={disabled}
      onClick={(e) => {
        e.stopPropagation();
        onCheckedChange?.(!isChecked);
      }}
      data-state={isChecked ? "checked" : isIndeterminate ? "indeterminate" : "unchecked"}
      className={cn(
        "peer inline-flex size-4 shrink-0 items-center justify-center rounded-[4px] border border-input shadow-xs outline-none transition-colors",
        "focus-visible:ring-[3px] focus-visible:ring-ring/50 focus-visible:border-ring",
        "disabled:cursor-not-allowed disabled:opacity-50",
        (isChecked || isIndeterminate) && "border-primary bg-primary text-primary-foreground",
        className,
      )}
      {...props}
    >
      {isIndeterminate ? (
        <Minus className="size-3.5" strokeWidth={3} />
      ) : isChecked ? (
        <Check className="size-3.5" strokeWidth={3} />
      ) : null}
    </button>
  );
}

export { Checkbox };
